import {
  MakePaymentVariables,
  PaymentStatusResponse,
  ZoneCartResponse,
  useMakePaymentMutation,
} from "../../api/pos-api";
import { PaymentType } from "../../api/types";
import { useState } from "react";
import { useAppDispatch } from "../../store";
import { setPaymentArgs, togglePaymentModal } from "../../store/slices/modalsSlice";
import { useParams, useSearchParams } from "react-router-dom";
import { MakePaymentFn, PaymentContextValue } from "./payment-context";
import { posApiInstance } from "../../api/axios/api-instances";

export const useAutonomousPayment = ({
  cart,
  manualLines,
  trackCarts,
}: {
  cart: ZoneCartResponse["result"]["cart"];
  manualLines: MakePaymentVariables["manual_lines"] | null;
  trackCarts: ZoneCartResponse["result"]["track_carts"];
}): PaymentContextValue => {
  const [payCheckout] = useMakePaymentMutation(undefined);
  const [loading, setLoading] = useState<PaymentType | null>(null);
  const dispatch = useAppDispatch();
  const { zoneId = "" } = useParams();
  const [searchParams] = useSearchParams();

  const handlePayCheckout: MakePaymentFn = async ({ type, onCheckoutCreated }) => {
    setLoading(type);

    try {
      const { result: checkoutId } = await payCheckout({
        zoneId: zoneId,
        checkout_datetime: searchParams.get("checkout_datetime")!,
        manual_lines: manualLines,
        cart,
        track_carts: trackCarts,
      }).unwrap();

      dispatch(
        setPaymentArgs({
          checkoutId: checkoutId,
          type,
        })
      );
      onCheckoutCreated?.(checkoutId);
    } finally {
      setLoading(null);
    }
  };

  const makePayment: MakePaymentFn = ({ type, checkin, onCheckoutCreated }) => {
    dispatch(togglePaymentModal({ open: true }));
    dispatch(
      setPaymentArgs({
        checkoutId: null,
        type,
      })
    );

    return handlePayCheckout({ type, checkin, onCheckoutCreated });
  };

  const fetchPaymentStatus = (checkoutId: string) => {
    return posApiInstance.get<PaymentStatusResponse>(`/internal/checkout/${checkoutId}/status`);
  };

  return {
    makePayment,
    loading,
    fetchPaymentStatus,
  };
};
